var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { useParams } from 'react-router';
import { useAtomValue } from 'jotai';
import { get } from 'lodash';

import { Translate } from "../../../../../I18N";
import { secondsToDate } from "../../../../shared/dateHelpers";
import { Truncate } from "../../../../Components/UI";
import { thesauriAtom } from "../../../../atoms";



// eslint-disable-next-line max-statements
const SuggestedValue = ({
  value,
  suggestion,
  templateProperties




}) => {
  const locale = useParams().lang;
  const thesauris = useAtomValue(thesauriAtom);

  let colorClass = '';
  if (!suggestion || suggestion.suggestedValue === '') {
    colorClass = 'text-orange-600';
  }
  if (value === suggestion.suggestedValue) {
    colorClass = 'text-green-600';
  } else {
    colorClass = 'text-orange-600';
  }

  const property = templateProperties.find((prop) => prop.name === suggestion.propertyName);
  const { content, type } = property || {};
  const thesaurus = thesauris.find((t) => t._id === content);

  const getLabelFromThesaurus = (id, _thesaurus) => {
    if (!_thesaurus) {
      return '';
    }

    const flattenedValues = _thesaurus.values.reduce((acc, v) => {
      if (v.values) {
        return [...acc, ...v.values];
      }
      return [...acc, v];
    }, []);

    const thesaurusValue = flattenedValues.find((v) => v.id === id);

    return (thesaurusValue === null || thesaurusValue === void 0 ? void 0 : thesaurusValue.label) || '';
  };

  const getCurrentValue = () => {
    if (value === '' || value === undefined) {
      return '-';
    }
    if (type === 'date') {
      return secondsToDate(value, locale);
    }

    if (type === 'select' || type === 'multiselect' || type === 'relationship') {
      const label = getLabelFromThesaurus(value, thesaurus);
      return /*#__PURE__*/_jsx(Translate, { context: content }, void 0, label);
    }

    return value === null || value === void 0 ? void 0 : value.toString();
  };

  const getSuggestedValue = () => {
    if (suggestion.suggestedValue === '') {
      return '-';
    }
    if (type === 'date') {
      return secondsToDate(suggestion.suggestedValue || '', locale);
    }
    if (type === 'select' || type === 'multiselect' || type === 'relationship') {
      const suggestedValueId =
      get(suggestion.suggestedValue, 'id') || suggestion.suggestedValue;
      const label = getLabelFromThesaurus(suggestedValueId, thesaurus);
      return /*#__PURE__*/_jsx(Translate, { context: content }, void 0, label);
    }
    return suggestion.suggestedValue.toString();
  };

  return (/*#__PURE__*/
    _jsx("div", { className: "flex flex-col gap-1" }, void 0, /*#__PURE__*/
    _jsx(Truncate, { maxLength: 100, ellipsisPosition: "center", tooltipClassname: "text-xs text-gray-500" }, void 0, /*#__PURE__*/
    _jsx("span", { className: "text-gray-500" }, void 0, getCurrentValue())
    ), /*#__PURE__*/
    _jsx(Truncate, { maxLength: 100, ellipsisPosition: "center", tooltipClassname: "text-xs" }, void 0,
    suggestion.state.obsolete && /*#__PURE__*/
    _jsx("span", { className: "text-gray-400 italic" }, void 0, "(", /*#__PURE__*/
    _jsx(Translate, {}, void 0, "obsolete"), ") ", getSuggestedValue()
    ),


    !suggestion.state.obsolete && !suggestion.state.error && /*#__PURE__*/
    _jsx("span", { className: `text-left ${colorClass}` }, void 0, getSuggestedValue())

    )
    ));

};

export { SuggestedValue };